import SliderData from "./SliderData";
import {featureGenerateColor} from "./featureGenerateColor";
import type {Block} from "./types";

export class featureGetBestColor {
  
  public block_id: number;
  public sliderData: SliderData;
  
  constructor( block_id: number, sliderData: SliderData ) {
    this.block_id = block_id;
    this.sliderData = sliderData;
  }

  public getColor(): string {
    let blockBefore: Block = this.sliderData.getBlockBefore(this.block_id);
    let blockAfter: Block = this.sliderData.getBlockAfter(this.block_id);
    let blockAfterAfter: Block = this.sliderData.getBlockAfter(blockAfter.id);
    if (blockBefore && blockAfter) {
      return featureGenerateColor.getColorBetween(blockBefore.color, blockAfter.color, 0.5);
    }
    if (blockBefore) {
      return blockBefore.color;
    }
    if (blockAfter && blockAfterAfter) {
      console.debug('blockAfterAfter, blockAfter', blockAfterAfter.color, blockAfter.color);
      let predictedColor: string =  featureGenerateColor.predictNextColor(blockAfter.color, blockAfterAfter.color);
      return featureGenerateColor.makeColorStronger(predictedColor, 0.8);
    }
    return '#FFFFFF';
  }
  


}